
// import React from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Button,
//   Chip,
//   Box,
//   Typography,
// } from '@mui/material';
// import { useHistory } from 'react-router-dom';
// import PersonIcon from '@mui/icons-material/Person';
// import VisibilityIcon from '@mui/icons-material/Visibility';

// const TClientes = (props) => {
//   let columns = [];
//   if (props.seleccionar !== undefined) {
//     columns = [
//       { id: 'nombre', label: 'NOMBRE', minWidth: 100 },
//       { id: 'apellido', label: 'APELLIDO/RAZÓN SOCIAL', minWidth: 200 },
//       { id: 'ci', label: 'CI', minWidth: 100 },
//       { id: 'ruc', label: 'RUC', minWidth: 100 },
//     ];
//   } else {
//     columns = [
//       { id: 'codcliente', label: 'CÓDIGO', minWidth: 80 },
//       { id: 'numcliente', label: 'N° CLIENTE', minWidth: 100 },
//       { id: 'nombre', label: 'NOMBRE', minWidth: 120 },
//       { id: 'apellido', label: 'APELLIDO/RAZÓN SOCIAL', minWidth: 200 },
//       { id: 'ci', label: 'CI', minWidth: 120 },
//       { id: 'ruc', label: 'RUC', minWidth: 120 },
//       { id: 'acciones', label: 'ACCIONES', minWidth: 120, align: 'center' },
//     ];
//   }

//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(10);
//   const { rows, termc } = props;
//   const history = useHistory();

//   const abrirPerfilCliente = (cliente) => {
//     history.push({ pathname: '/clientePerfil', state: cliente });
//   };

//   function searchingTermc(termc) {
//     return function (x) {
//       const nombre = x.nombre || '';
//       const apellido = x.apellido || '';
//       const codcliente = x.codcliente || 0;
//       const ci = x.ci || '';
//       const ruc = x.ruc || '';
      
//       return (
//         nombre.toUpperCase().includes(termc.toUpperCase()) ||
//         apellido.toUpperCase().includes(termc.toUpperCase()) ||
//         codcliente.toString().toUpperCase().includes(termc.toUpperCase()) ||
//         ci.toUpperCase().includes(termc.toUpperCase()) ||
//         ruc.toUpperCase().includes(termc.toUpperCase()) ||
//         !termc
//       );
//     };
//   }

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const filteredRows = (rows || []).filter(searchingTermc(termc));
//   const paginatedRows = filteredRows.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   if (props.seleccionar === undefined) {
//     return (
//       <Box>
//         <TableContainer sx={{ maxHeight: 600 }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 {columns.map((column) => (
//                   <TableCell
//                     key={column.id}
//                     align={column.align || 'left'}
//                     sx={{
//                       minWidth: column.minWidth,
//                       fontWeight: 700,
//                       backgroundColor: '#e3f2fd',
//                       color: 'primary.main',
//                       fontSize: '0.875rem',
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.5px',
//                       borderBottom: 2,
//                       borderColor: 'primary.main',
//                     }}
//                   >
//                     {column.label}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedRows.length > 0 ? (
//                 paginatedRows.map((cliente, index) => (
//                   <TableRow
//                     key={cliente.clientE_Id}
//                     sx={{
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       '&:nth-of-type(even)': {
//                         backgroundColor: 'action.hover',
//                       },
//                       transition: 'background-color 0.2s ease',
//                     }}
//                   >
//                     <TableCell>
//                       <Chip
//                         label={cliente.codcliente}
//                         size="small"
//                         color="primary"
//                         variant="outlined"
//                         sx={{ fontWeight: 600 }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2" fontWeight={500}>
//                         {cliente.numcliente}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <PersonIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
//                         <Typography variant="body2" fontWeight={500}>
//                           {cliente.nombre || '-'}
//                         </Typography>
//                       </Box>
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2">
//                         {cliente.apellido || '-'}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2" fontFamily="monospace">
//                         {cliente.ci || '-'}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2" fontFamily="monospace">
//                         {cliente.ruc || '-'}
//                       </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Button
//                         variant="contained"
//                         size="small"
//                         startIcon={<VisibilityIcon />}
//                         onClick={() => abrirPerfilCliente(cliente)}
//                         sx={{
//                           textTransform: 'none',
//                           fontWeight: 600,
//                           borderRadius: 1.5,
//                           px: 2,
//                           boxShadow: 1,
//                           '&:hover': {
//                             boxShadow: 3,
//                             transform: 'translateY(-1px)',
//                           },
//                           transition: 'all 0.2s ease',
//                         }}
//                       >
//                         Ver Perfil
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={columns.length} align="center" sx={{ py: 8 }}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         gap: 2,
//                         color: 'text.secondary',
//                       }}
//                     >
//                       <PersonIcon sx={{ fontSize: 64, opacity: 0.3 }} />
//                       <Typography variant="h6">
//                         No se encontraron clientes
//                       </Typography>
//                       <Typography variant="body2">
//                         {termc
//                           ? 'Intenta con otros términos de búsqueda'
//                           : 'Aún no hay clientes registrados'}
//                       </Typography>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[10, 25, 50, 100]}
//           component="div"
//           count={filteredRows.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           labelRowsPerPage="Filas por página:"
//           labelDisplayedRows={({ from, to, count }) =>
//             `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
//           }
//           sx={{
//             borderTop: 1,
//             borderColor: 'divider',
//             '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
//               fontWeight: 500,
//             },
//           }}
//         />
//       </Box>
//     );
//   } else {
//     // Modo selección
//     return (
//       <Box>
//         <TableContainer sx={{ maxHeight: 600 }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 {columns.map((column) => (
//                   <TableCell
//                     key={column.id}
//                     align={column.align || 'left'}
//                     sx={{
//                       minWidth: column.minWidth,
//                       fontWeight: 700,
//                       backgroundColor: '#e3f2fd',
//                       color: 'primary.main',
//                       fontSize: '0.875rem',
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.5px',
//                       borderBottom: 2,
//                       borderColor: 'primary.main',
//                     }}
//                   >
//                     {column.label}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedRows.map((row) => (
//                 <TableRow
//                   hover
//                   role="checkbox"
//                   tabIndex={-1}
//                   key={row.ci}
//                   onClick={() => {
//                     props.seleccionar(row);
//                     props.setTermc('');
//                   }}
//                   sx={{
//                     cursor: 'pointer',
//                     '&:hover': {
//                       backgroundColor: '#f5f5f5',
//                     },
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   {columns.map((column) => {
//                     const value = row[column.id];
//                     return (
//                       <TableCell key={column.id} align={column.align || 'left'}>
//                         <Typography variant="body2" fontWeight={500}>
//                           {column.format && typeof value === 'number'
//                             ? column.format(value)
//                             : value || '-'}
//                         </Typography>
//                       </TableCell>
//                     );
//                   })}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[10, 25, 50, 100]}
//           component="div"
//           count={filteredRows.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           labelRowsPerPage="Filas por página:"
//           labelDisplayedRows={({ from, to, count }) =>
//             `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
//           }
//           sx={{
//             borderTop: 1,
//             borderColor: 'divider',
//           }}
//         />
//       </Box>
//     );
//   }
// };

// export default TClientes;


import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Chip,
  Box,
  Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';

const TClientes = (props) => {
  let columns = [];
  if (props.seleccionar !== undefined) {
    columns = [
      { id: 'nombre', label: 'NOMBRE', minWidth: 100 },
      { id: 'apellido', label: 'APELLIDO/RAZÓN SOCIAL', minWidth: 200 },
      { id: 'ci', label: 'CI', minWidth: 100 },
      { id: 'ruc', label: 'RUC', minWidth: 100 },
    ];
  } else {
    columns = [
      // { id: 'codcliente', label: 'CÓDIGO', minWidth: 80 },
      { id: 'numcliente', label: 'N° CLIENTE', minWidth: 100 },
      { id: 'nombre', label: 'NOMBRE', minWidth: 120 },
      { id: 'apellido', label: 'APELLIDO/RAZÓN SOCIAL', minWidth: 200 },
      { id: 'ci', label: 'CI', minWidth: 120 },
      { id: 'ruc', label: 'RUC', minWidth: 120 },
      { id: 'acciones', label: 'ACCIONES', minWidth: 120, align: 'center' },
    ];
  }

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
const {
  rows = [],
  termc = '',
  paginacionExterna = false,
} = props;
  const history = useHistory();

  const abrirPerfilCliente = (cliente) => {
    history.push({ pathname: '/clientePerfil', state: cliente });
  };

  function searchingTermc(termc) {
    return function (x) {
      const nombre = x.nombre || '';
      const apellido = x.apellido || '';
      const codcliente = x.codcliente || 0;
      const ci = x.ci || '';
      const ruc = x.ruc || '';
      
      return (
        nombre.toUpperCase().includes(termc.toUpperCase()) ||
        apellido.toUpperCase().includes(termc.toUpperCase()) ||
        codcliente.toString().toUpperCase().includes(termc.toUpperCase()) ||
        ci.toUpperCase().includes(termc.toUpperCase()) ||
        ruc.toUpperCase().includes(termc.toUpperCase()) ||
        !termc
      );
    };
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

// Cuando la paginación es externa, el backend ya filtró
// y devolvió únicamente los registros de la página actual.
const filteredRows = paginacionExterna
  ? rows
  : rows.filter(searchingTermc(termc));

// Evita paginar dos veces.
const paginatedRows = paginacionExterna
  ? filteredRows
  : filteredRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
React.useEffect(() => {
  if (!paginacionExterna) {
    setPage(0);
  }
}, [termc, paginacionExterna]);
  if (props.seleccionar === undefined) {
    return (
      <Box>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    sx={{
                      minWidth: column.minWidth,
                      fontWeight: 700,
                      backgroundColor: '#e3f2fd',
                      color: 'primary.main',
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      borderBottom: 2,
                      borderColor: 'primary.main',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.length > 0 ? (
                paginatedRows.map((cliente, index) => (
                  <TableRow
                    key={cliente.clientE_Id}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      '&:nth-of-type(even)': {
                        backgroundColor: 'action.hover',
                      },
                      transition: 'background-color 0.2s ease',
                    }}
                  >
                    {/* <TableCell>
                      <Chip
                        label={cliente.codcliente}
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ fontWeight: 600 }}
                      />
                    </TableCell> */}
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>
                        {cliente.numcliente}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PersonIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        <Typography variant="body2" fontWeight={500}>
                          {cliente.nombre || '-'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {cliente.apellido || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontFamily="monospace">
                        {cliente.ci || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontFamily="monospace">
                        {cliente.ruc || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={() => abrirPerfilCliente(cliente)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: 1.5,
                          px: 2,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Ver Perfil
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center" sx={{ py: 8 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        color: 'text.secondary',
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                      <Typography variant="h6">
                        No se encontraron clientes
                      </Typography>
                      <Typography variant="body2">
                        {termc
                          ? 'Intenta con otros términos de búsqueda'
                          : 'Aún no hay clientes registrados'}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        
       {!paginacionExterna && (
  <TablePagination
    rowsPerPageOptions={[10, 25, 50, 100]}
    component="div"
    count={filteredRows.length}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    labelRowsPerPage="Filas por página:"
    labelDisplayedRows={({ from, to, count }) =>
      `${from}-${to} de ${
        count !== -1 ? count : `más de ${to}`
      }`
    }
    sx={{
      borderTop: 1,
      borderColor: 'divider',
    }}
  />
)}
      </Box>
    );
  } else {
    // Modo selección
    return (
      <Box>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    sx={{
                      minWidth: column.minWidth,
                      fontWeight: 700,
                      backgroundColor: '#e3f2fd',
                      color: 'primary.main',
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      borderBottom: 2,
                      borderColor: 'primary.main',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row) => (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.ci}
                  onClick={() => {
                    props.seleccionar(row);
                    props.setTermc('');
                  }}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align || 'left'}>
                        <Typography variant="body2" fontWeight={500}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value || '-'}
                        </Typography>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
     {!paginacionExterna && (
  <TablePagination
    rowsPerPageOptions={[10, 25, 50, 100]}
    component="div"
    count={filteredRows.length}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    labelRowsPerPage="Filas por página:"
    labelDisplayedRows={({ from, to, count }) =>
      `${from}-${to} de ${
        count !== -1 ? count : `más de ${to}`
      }`
    }
    sx={{
      borderTop: 1,
      borderColor: 'divider',
    }}
  />
)}
      </Box>
    );
  }
};

export default TClientes;